var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.948,
    height: 17.402,
    viewBox: "0 0 10.948 17.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13978",
    "data-name": "Path 13978",
    d: "M240.19,23.479l-.589,4.69H230.83l-.588-4.69a5.227,5.227,0,0,1,.8-2.792,5.039,5.039,0,0,1,2.07-1.861V18.3a3.54,3.54,0,0,1-.953-1.206,3.617,3.617,0,0,1,.644-4.06,3.338,3.338,0,0,1,4.718-.11q.057.055.11.11a3.618,3.618,0,0,1,.645,4.06,3.54,3.54,0,0,1-.953,1.206v.524a5,5,0,0,1,.751.45,4.946,4.946,0,0,1,.661.574,5.115,5.115,0,0,1,1.066,1.632,5.266,5.266,0,0,1,.392,2",
    transform: "translate(-229.742 -11.267)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.cb9914748a526d6b091a3fe49b9a8a8a.svg";
export { ForwardRef as ReactComponent };